import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Row } from "reactstrap";
import truckyService from "../common/services/trucky-service";

const BENEFITS = [
  { key: "support",   title: "Support Trucky" },
  { key: "wall",      title: "Place on Patrons Wall of Fame" },
  { key: "premium",  title: "Premium Features" },
  { key: "noads",    title: "No Ads" },
  { key: "preview",  title: "Access to Preview Releases" },
];

const PLANS = [
  {
    name: "Friend",
    icon: "heart",
    month: 1,
    year: 10,
    featured: false,
    benefits: { support: true, wall: true, premium: false, noads: false, preview: false },
  },
  {
    name: "Angel",
    icon: "crown",
    month: 5,
    year: 54,
    featured: true,
    benefits: { support: true, wall: true, premium: true, noads: true, preview: true },
  },
  {
    name: "Fan",
    icon: "star",
    month: 3,
    year: 32,
    featured: false,
    benefits: { support: true, wall: true, premium: true, noads: true, preview: false },
  },
  
];

const Plans = ({ container }) => {
  const formatPrice = (month, year) =>
    container.localeManager.formatString(
      container.localeManager.strings.subscriptionPricing,
      [month, year]
    );

  return (
    <>
      {/* Hero */}
      <div className="premium-hero text-center mb-5">
        <div className="premium-hero-badge">
          <FontAwesomeIcon icon="star" className="mx-0 me-2" />
          Trucky Premium
        </div>
        <h2 className="premium-hero-title">
          {container.localeManager.strings.becomePatronText}
        </h2>
        <p className="premium-hero-sub">
          Support an independent app. Remove ads. Unlock exclusive features.
        </p>
      </div>

      {/* Plans */}
      <Row className="g-4 justify-content-center align-items-stretch">
        {PLANS.map((plan) => (
          <Col key={plan.name} xs={12} md={4}>
            <div className={`premium-plan-card${plan.featured ? " premium-plan-featured" : ""}`}>
              {plan.featured && (
                <div className="premium-plan-badge">
                  <FontAwesomeIcon icon="star" className="mx-0 me-1" />
                  Most Popular
                </div>
              )}
              <div className="premium-plan-header">
                <div className="premium-plan-icon">
                  <FontAwesomeIcon icon={plan.icon} className="mx-0" />
                </div>
                <h3 className="premium-plan-name">{plan.name}</h3>
                <div className="premium-plan-price">
                  <span className="premium-plan-price-amount">${plan.month}</span>
                  <span className="premium-plan-price-period">/month</span>
                </div>
                <div className="premium-plan-price-annual">
                  or ${plan.year}/year <span className="premium-plan-save">save ~{Math.round(100 - (plan.year / (plan.month * 12)) * 100)}%</span>
                </div>
              </div>

              <ul className="premium-plan-benefits">
                {BENEFITS.map((b) => (
                  <li key={b.key} className={`premium-plan-benefit${plan.benefits[b.key] ? " enabled" : " disabled"}`}>
                    <FontAwesomeIcon
                      className="mx-0 flex-shrink-0"
                      icon={plan.benefits[b.key] ? "check-circle" : "times-circle"}
                    />
                    <span>{b.title}</span>
                  </li>
                ))}
              </ul>

              <a
                href="https://www.patreon.com/truckyapp"
                target="_blank"
                rel="noreferrer"
                className={`premium-plan-cta${plan.featured ? " featured" : ""}`}
              >
                <FontAwesomeIcon icon={["fab", "patreon"]} className="mx-0 me-2" />
                {container.localeManager.strings.becomeAPatron}
              </a>
            </div>
          </Col>
        ))}
      </Row>

      {/* Footer link */}
      <div className="text-center mt-5 pb-3">
        <a
          className="text-muted"
          style={{ cursor: "pointer", fontSize: "0.9rem" }}
          onClick={() =>
            truckyService.openUrlInDefaultBrowser(
              "https://truckyapp.com/kb/how-to-connect-the-app-to-patreon/"
            )
          }
        >
          <FontAwesomeIcon icon="link" className="me-1" />
          {container.localeManager.strings.connectPatreonLink}
        </a>
      </div>
    </>
  );
};

export default Plans;
